import { formatDuration } from '@/helpers/timeHelpers';

export function getHoldGain(rewardAmount: number, holdAmount: number): number {
  try {
    return rewardAmount / holdAmount;
  } catch {
    return 0;
  }
}

export function getHoldTotal(rewardAmount: number, holdAmount: number): number {
  return rewardAmount + holdAmount;
}

export function getHoldPeriod(period: number): string {
  if (isNaN(period)) {
    return '∞';
  }

  return formatDuration(period * 1000);
}
